import React, { Component, } from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import {CCActions} from './../../cc-imports'


class Help extends Component {

    static propTypes = {}

    static defaultProps = {}

    constructor(props) {
        super(props)
        this.state = {
            recentMatches: [],
            upcomingMatches: [],
            upcomingLeagues: [],
            user: {},
            displayNameErr : null,
            emailErr : null
        }
    }

    componentWillMount(){
        /*BackHandler.addEventListener('hardwareBackPress', () => {
            if (this.props.profileTabNavigation && this.props.profileTabNavigation.index > 0 ) {
                this.props.actions.goBack();
                return true;
            }
            return false;
        });*/
    }

    componentDidMount() {

    }

    render() {
        let user = this.props.user.user;
        return (
            <div/>
        )
    }
}

export default connect(state=>({
    profile : state.profile,
    profileTabNavigation:state.profileTabNavigation,
    user : state.user,
    fireBaseUser : state.fireBaseUser
}), (dispatch)=>({
    actions: bindActionCreators({...CCActions}, dispatch),
    dispatch: dispatch
}))(Help);


// WEBPACK FOOTER //
// ./src/app/screens/Help/Help.js